<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase" @click="goToHomePage()">
        <div style="cursor: pointer">
          <span>DISASTER</span>
          <span class="font-weight-light">MANAGEMENT</span>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    //
  }),
  methods: {
    goToHomePage() {
      window.location.href = "/";
    }
  }
};
</script>
